import { Component, OnInit, TemplateRef, OnDestroy } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { PHBHPFeaturePackageConfigurationService } from '../../configure/ph-bhp-feature-package-configuration.service';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { Department } from '../../configure/Models/Department';
import { AppConfig } from 'src/app/app.config';
import { TranslationKeys } from 'ph-bhp-localization';

@Component({
  selector: 'lib-ph-bhp-observe-new-quota',
  templateUrl: './ph-bhp-observe-new-quota.component.html',
  styleUrls: ['./ph-bhp-observe-new-quota.component.css']
})
export class PhBhpConfigureNewQuotaComponent implements OnInit, OnDestroy {
  addQuotaInfo: UntypedFormGroup;
  userData: any;
  institutionID: number;
  quotaID: number;
  quotaDetail: any;
  quotaFlag: boolean = true;
  subscription: Subscription;
  wardList: Array<any>;
  departmentList: Array<Department>;
  minDate: Date = new Date();
  minEndDate: Date = new Date();
  endDate: Date = new Date();
  modalRef: BsModalRef;
  title;
  status = 0;
  wardFocusChanged = true;
  departmentFocusChanged = true;
  translationKeys: typeof TranslationKeys = TranslationKeys;

  constructor(
    private modalService: BsModalService,
    private router: Router,
    public translate: TranslateService,
    private service: PHBHPFeaturePackageConfigurationService,
    private layoutService: PHBHPLayoutPackageService,
    private activatedRoute: ActivatedRoute,
    public appConfig: AppConfig
  ) {
  }

  ngOnInit() {
    this.quotaID = this.activatedRoute.snapshot.params.quotaID;
    if (this.quotaID) {
      this.title = this.layoutService.translateText('CONFIGURE.EDIT_QUOTA');//"Edit quota";
    } else {
      this.title = this.layoutService.translateText('CONFIGURE.ADD_NEW_QUOTA');//"Add new quota";
    }
    //this.getDepartmentList();
    this.addQuotaInfo = new UntypedFormGroup({
      wardName: new UntypedFormControl('', Validators.compose([Validators.required])),
      departmentName: new UntypedFormControl('', Validators.compose([Validators.required])),
      startDate: new UntypedFormControl('', Validators.compose([Validators.required])),
      endDate: new UntypedFormControl('', Validators.compose([Validators.required])),
      numberofDays: new UntypedFormControl('', Validators.compose([Validators.required])),
      numberofQuota: new UntypedFormControl('', Validators.compose([Validators.required])),
      wardID: new UntypedFormControl('', Validators.compose([Validators.required])),
      departmentTypeID: new UntypedFormControl('', Validators.compose([Validators.required])),
      departmentTypeName: new UntypedFormControl('', Validators.compose([Validators.required])),
    });

    if (this.layoutService.institutionID) {
      this.institutionID = this.layoutService.institutionID;
      //this.userData =
      this.getWardList();
    }
    this.subscription = this.layoutService.institutionIDSubject.asObservable().subscribe((res) => {
      this.institutionID = this.layoutService.institutionID;
      this.getWardList();
    });
  }

  ngOnDestroy() {
    if (this.subscription)
      this.subscription.unsubscribe();
  }

  getQuotaDetail() {
    if (this.quotaID && this.quotaFlag) {
      this.quotaFlag = false;
      this.service.getQuotaDetail(this.quotaID, this.institutionID).subscribe((res) => {
        this.quotaDetail = res;
        this.minDate = this.layoutService.convertLocalDateToUTC(new Date(res.startDateTime));
        this.minEndDate = this.minDate;
        var department = this.departmentList.find(dep => dep.departmentID == res.departmentID);
        var ward = this.wardList.find(wd => wd.wardID == res.wardID)
        this.addQuotaInfo.setValue({
          wardName: ward.wardName,
          wardID: ward.wardID,
          departmentName: department || '',
          startDate: this.minDate,
          endDate: this.layoutService.convertLocalDateToUTC(new Date(res.endDateTime)),
          numberofDays: res.numberOfDays,
          numberofQuota: res.totalQuotas,
          departmentTypeID: ward.departmentTypeID,
          departmentTypeName: ward.departmentTypeName
        })
        this.addQuotaInfo.patchValue({
          wardID: ward.wardID,
        });
        this.status = this.quotaDetail.status; //status: 2
        if (this.status == 2) {
          this.addQuotaInfo.get('startDate').setValidators(null);
          this.addQuotaInfo.get('startDate').setErrors(null);
        }
      })

    }

  }
  selectStartDate() {
    if (this.addQuotaInfo.value.startDate != "") { //CONFLICT:This 'if' condition was not present on phase1, code within was executed always.
      var oneDay = 24 * 60 * 60 * 1000;
      this.minEndDate = this.addQuotaInfo.value.startDate;
      this.addQuotaInfo.patchValue({ endDate: "" })
    }
  }

  selectEndDate() {
    if (this.addQuotaInfo.value.startDate != "" && this.addQuotaInfo.value.endDate != "") {
      var oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
      this.endDate = this.addQuotaInfo.value.endDate;
      var startDateTime = new Date(this.addQuotaInfo.value.startDate.getFullYear(), this.addQuotaInfo.value.startDate.getMonth(), this.addQuotaInfo.value.startDate.getDate());
      var endDateTime = new Date(this.addQuotaInfo.value.endDate.getFullYear(), this.addQuotaInfo.value.endDate.getMonth(), this.addQuotaInfo.value.endDate.getDate(), 23, 59, 59);
      var numberofDays = Math.round(Math.abs((endDateTime.getTime() - startDateTime.getTime()) / oneDay));
      this.addQuotaInfo.patchValue({ numberofDays: numberofDays })
    }
  }
  saveQuota() {
    if (this.addQuotaInfo.invalid) {
      return false;
    }
    this.userData = this.appConfig.userData;
    var startDateTime = this.layoutService.convertUTCDateToLocalDate(new Date(this.addQuotaInfo.value.startDate.getFullYear(), this.addQuotaInfo.value.startDate.getMonth(), this.addQuotaInfo.value.startDate.getDate()));
    var endDateTime = this.layoutService.convertUTCDateToLocalDate(new Date(this.addQuotaInfo.value.endDate.getFullYear(), this.addQuotaInfo.value.endDate.getMonth(), this.addQuotaInfo.value.endDate.getDate(), 21, 59, 59));

    if (!this.quotaID) {
      this.createQuota(startDateTime, endDateTime)
    } else {
      this.updateQuota(startDateTime, endDateTime)
    }

  }

  updateQuota(startDateTime, endDateTime) {
    var userId = this.userData.userId;
    var data = this.quotaDetail;
    data.institutionID = this.institutionID;
    data.wardID = this.addQuotaInfo.value.wardID;
    data.departmentID = this.addQuotaInfo.value.departmentName.departmentID;
    data.startDateTime = startDateTime.toISOString();
    data.endDateTime = endDateTime.toISOString();
    data.numberOfDays = this.addQuotaInfo.value.numberofDays;
    data.totalQuotas = this.addQuotaInfo.value.numberofQuota;
    data.updatedBy = userId;
    this.layoutService.showLoader = true;
    this.service.updateQuota(this.quotaID, data).subscribe(res => {
      // this.layoutService.showSuccess(this.layoutService.translateText('CONFIGURE.MESSAGE_SUCCESSFULLY.UPDATED.QUOTA'))
      this.layoutService.showLoader = false;
      this.backManageQuota();
    })
  }

  createQuota(startDateTime, endDateTime) {
    var userId = this.userData.userId;
    var data = {
      institutionID: this.institutionID,
      wardID: this.addQuotaInfo.value.wardID,
      departmentID: this.addQuotaInfo.value.departmentName.departmentID,
      departmentTypeID: this.addQuotaInfo.value.departmentTypeID,
      startDateTime: startDateTime.toISOString(),
      endDateTime: endDateTime.toISOString(),
      numberOfDays: this.addQuotaInfo.value.numberofDays,
      totalQuotas: this.addQuotaInfo.value.numberofQuota,
      status: 3,
      createdBy: userId
    }
    this.layoutService.showLoader = true;
    this.service.createQuota(data).subscribe(res => {
      // this.layoutService.showSuccess(this.layoutService.translateText("CONFIGURE.MESSAGE_SUCCESSFULLY.CREATED.QUOTA"));
      this.layoutService.showLoader = false;
      this.backManageQuota();
    })
  }

  backManageQuota() {
    this.router.navigate(['/observe/managequota']);
  }
  cancelQuota(deletemodal: TemplateRef<any>) {
    this.modalRef = this.modalService.show(deletemodal, Object.assign({}, { class: 'w-420' })
    )
  }
  getWardList() {
    this.layoutService.showLoader = true;
    this.service.getWardsAndDepartments(this.institutionID).subscribe((res: any) => {
      this.layoutService.showLoader = false;
      if (res == null) {
        //this.wardWarningMessage = true;
        return;
      }
      if (res && res['wardsDetails']) this.wardList = res['wardsDetails'];
      if (res && res['departments']) this.departmentList = res['departments'];
      //this.wardList = res;

      //CONFLICT: this method was implemented like below on phase1
      this.service.getWardsbyInstitutionId(this.institutionID).subscribe((res: any[]) => {
        this.wardList = res;
        this.getQuotaDetail();
        this.getDepartment(this.wardList[0]);
      })
    })
  }

  getDepartment(ward: any) {
    this.addQuotaInfo.patchValue({
      wardID: ward.wardID,
      wardName: ward.wardName,
      departmentTypeID: ward.departmentTypeID,
      departmentTypeName: ward.departmentTypeName
    });
    var department = this.departmentList.find(res => res.departmentID === ward.departmentID);// this.addQuotaInfo.value.wardName.departmentID);
    if (this.addQuotaInfo.value.wardName && this.wardFocusChanged) {
      this.departmentFocusChanged = false;
      this.addQuotaInfo.patchValue({ departmentName: department })
      this.departmentFocusChanged = true;
    } else {
      this.wardFocusChanged = true;
      this.departmentFocusChanged = true;
    }
    //CONFLICT: this method was implemented like below on phase1
    // var department = this.departmentList.find(res => res.departmentID == this.addQuotaInfo.value.wardName.departmentID)
    // this.addQuotaInfo.patchValue({ departmentName: department })
  }
  getDepartmentList() {
    this.layoutService.showLoader = true;
    this.service.getDepartmentDetails().subscribe((res: Department[]) => {
      this.layoutService.showLoader = false;
      this.departmentList = res;
    });
  }
  getWardForChangedDepartment(event) {

    if (this.addQuotaInfo.value.departmentName !== '' && this.departmentFocusChanged) {
      const ward = this.wardList.find(res => res.departmentID === this.addQuotaInfo.value.departmentName.departmentID);
      this.wardFocusChanged = false;
      this.addQuotaInfo.patchValue({ wardName: ward.wardName, wardID: ward.wardID });
      this.wardFocusChanged = true;
    } else {
      this.wardFocusChanged = true;
      this.departmentFocusChanged = true;
    }
  }
}
